
export enum PaymentMethodType {
    CreditCard = "credit-card",
    ACH = "ach",
    PayByBank = "pay-by-bank"
};

export enum BankAccountType {
    Personal = "personal",
    Business = "business"
}

export enum CreditCardType {
    Visa = "Visa",
    AmericanExpress = "American Express",
    Discover = "Discover",
    MasterCard = "MasterCard",
    Other = "Card"
};

export interface ConnectedBankAccount {
    bankIcon: string;
    bankName?: string | undefined;
    accountName: string;
    accountMask: string;
    selected: boolean;
    accountType: string;
    bankId?: string | undefined;
    accountId?: string | undefined;
    publicToken?: string | undefined;
    verificationStatus?: string | undefined;
}

export interface PaymentMethodInfo {
    paymentMethodId: number;
    primary: boolean;
    name: string;
    selected: boolean;
    icon: string;
    expires?: string | undefined;
    customerName?: string | undefined;
    bankName?: string | undefined;
    bankId?: string | undefined;
    number?: string | undefined;
    paymentMethodType: PaymentMethodType,
    displayText?: string | undefined;
    customerId?: number;
    membership?: boolean;
    disconnected?: boolean | undefined;
    routingNumber?: string | undefined;
    token?: string | undefined;
    accountId?: string | undefined;
    bankAccountType?: BankAccountType | undefined;
    postalCode?: string | undefined;
    cvv?: string | undefined;
    verificationStatus?: string | undefined;
    storePaymentMethod?: boolean | undefined; /* Only used for credit card to save and charge at same time */
}